import { render, staticRenderFns } from "./CompanySelectionScreen.vue?vue&type=template&id=42753ac2&"
import script from "./CompanySelectionScreen.vue?vue&type=script&lang=js&"
export * from "./CompanySelectionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports